<template>
  <div class="mySetMeal">
    <a-tabs defaultActiveKey="1" @change="callback">
      <a-tab-pane :tab="$tc('lang.UserCenter.Package_List')" key="1">
        <set-meal-list></set-meal-list>
      </a-tab-pane>
      <a-tab-pane :tab="$tc('lang.UserCenter.Purchase_Record')" key="2">
        <buy-list></buy-list>
      </a-tab-pane>
      <a-tab-pane :tab="$tc('lang.UserCenter.Consume_Record')" key="3">
        <use-list></use-list>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import setMealList from './mySetMealComponents/setMealList';
import buyList from './mySetMealComponents/buyList';
import useList from './mySetMealComponents/useList';
export default {
  data() {
    return {};
  },
  components: {
    setMealList,
    buyList,
    useList,
  },
  methods: {
    callback(key) {
      console.log(key);
    },
  },
};
</script>
<style lang="less">
.mySetMeal {
  margin-top: 3%;
  text-align: left;
}
</style>
